export default "__VITE_ASSET__DCMyBleC__"